module.exports = __webpack_public_path__ + "static/media/bg-auth.33e8b5b6.jpg";